import * as types from './actionTypes';  
import brokerDealerAdminsApi from '../api/brokerDealerAdminsApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doBrokerDealerAdmins(mpid) {

  return {
    type: types.DO_BROKERDEALER_ADMINS,
    mpid
  };
}

export function doBrokerDealerAdminsRes(data) {  
  return {
    type: types.DO_BROKERDEALER_ADMINS_RES, 
    data
  };
}

export function getBrokerDealerAdmins(mpid) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      brokerDealerAdminsApi.doBrokerDealerAdmins(mpid).then(data => {
        dispatch(doBrokerDealerAdminsRes(data));
        dispatch(doBrokerDealerAdminsRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}